var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import { VBox, HBox } from "framework/structural_components/hbox_vbox";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { useRegistrationSubState, useEventCalendarCompetitors } from "./store";
import { cls_table_body, cls_table_body_dense, cls_table_caption_row, cls_table_caption_row_dense, cls_table_caption_row_hover_background, cls_table_cell, cls_table_row } from "style/table.css";
import { cls_backgroundBlue70, cls_backgroundGreen5, cls_backgroundOrange40, cls_colorCyan70, cls_colorMagenta60, cls_cursor_pointer, cls_gap_form, cls_gap_half_rem, cls_gap_quarter_rem, cls_p5b, cls_p5r, cls_p6r, cls_rotate_180deg, cls_rotate_90deg, cls_wrap } from "style/index.css";
import { EventType, StartType } from "../../entity";
import { getCompetitionNaming, getCompetitorTypeRegular } from "../../../view/entity";
import { cls_competitor_club, cls_competitor_name_couple, cls_competitor_name_solo, cls_comp_competitors_box, cls_unregistered, cls_button_width, cls_button_box_width, cls_button_or_message, cls_button_or_message_mobile, cls_competitor_name_group, cls_box_number_of_competitors, cls_competitor_start_type_box, cls_competitor_start_type_sign, cls_competitor_start_type_box_mobile, cls_background_asterisk_black, cls_background_asterisk_white, cls_competitor_with_sub_members_hover_background, cls_no_members_marker } from "./view.css";
import { cls_align_items_center, cls_align_items_flex_end, cls_align_items_flex_start, cls_align_items_stretch, cls_justify_content_center, cls_justify_content_flex_end, cls_justify_content_space_between } from "framework/structural_components/hbox_vbox.css";
import { useResponsivity } from "framework/responsivity/store";
import { Button, ButtonNoStyle, ButtonSmall, Intent } from "framework/controls/button";
import { cls_item_detail_link } from "../list/view.css";
import { useUIContext } from "common/uicontext/store";
import { useif } from "framework/state/types";
import { Dialog, DialogContent, DialogTitle } from "framework/dialog/dialog";
import { cls_gap_line } from "style/index.css";
import { CompetitorType } from "../../entity";
import { getDateAndTimeText_DayMonthHourMinute, getDateComparison, getIsoStringDate, isValidDate } from "framework/helpers";
import { cls_link_blue } from "framework/link/link.css";
import { cls_chevron_right_black_box, cls_chevron_right_white_box, cls_icon_box_size_18px, cls_icon_box_size_24px } from "style/icons.css";
import { UrlPathOfApiLocation } from "common/paths";
import { useEventCalendarList } from "../store";
import { competitorHasSubMembers, GroupOrFormationMembersDialog } from "../competition_registration/competitions/viewGroupMembersDialog";
import { useCompetitionRegistration } from "../competition_registration/store";
var ConfirmCancelRegistrationDialog = function (props) {
    var _a = useEventCalendarCompetitors(), actions = _a[1];
    var c = props.competitor;
    var cancelRegistrationState = useRegistrationSubState({ competitorId: c.competitorId, competitionId: c.competitionId })[0];
    var confirmCancelingRegistration = function () {
        actions.cancelRegistrationOfCompetitor(props.eventId, c.competitionId, c.competitorId);
    };
    var cancel = function () {
        actions.closeConfirmDialog(c.competitorId, c.competitionId);
    };
    var confirmText = "Opravdu chcete provést odhlášení ze soutěže?";
    if (c.type == CompetitorType.Couple || props.competitor.type == CompetitorType.Duo || c.type === CompetitorType.ProAm) {
        if (c.couplesOrDuos !== undefined && c.couplesOrDuos.length === 1) {
            var name = c.couplesOrDuos[0].name1 + ' ' + c.couplesOrDuos[0].surname1 + ' & ' + c.couplesOrDuos[0].name2 + ' ' + c.couplesOrDuos[0].surname2;
            confirmText = "Opravdu chcete ze sout\u011B\u017Ee odhl\u00E1sit ".concat(c.type === CompetitorType.Couple || c.type === CompetitorType.ProAm ? 'pár' : 'duo', " ").concat(name, "?");
        }
    }
    if (props.competitor.type == CompetitorType.SoloDancer) {
        if (c.persons !== undefined && c.persons.length === 1) {
            var competitor_naming = 'soutěžící';
            var name = c.persons[0].name + ' ' + c.persons[0].surname;
            if (c.persons[0].sex == "F") {
                competitor_naming = "tanečnici";
            }
            else if (c.persons[0].sex == "M") {
                competitor_naming = "tanečníka";
            }
            confirmText = "Opravdu chcete ze soutěže odhlásit " + competitor_naming + " " + name + "?";
        }
    }
    if (props.competitor.type == CompetitorType.Group) {
        confirmText = "Opravdu chcete tuto skupinu odhlásit ze soutěže?";
    }
    if (props.competitor.type == CompetitorType.Formation) {
        confirmText = "Opravdu chcete tuto formaci odhlásit ze soutěže?";
    }
    if (props.competitor.type == CompetitorType.Team) {
        confirmText = "Opravdu chcete tento tým odhlásit ze soutěže?";
    }
    if (props.competitor.type == CompetitorType.Formation) {
        confirmText = "Opravdu chcete tuto formaci odhlásit ze soutěže?";
    }
    return React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: cancelRegistrationState.showDialog },
            React.createElement(DialogContent, null,
                React.createElement(DialogTitle, null, "Potvrzení odhlášení ze soutěže"),
                React.createElement(VBox, { className: [cls_gap_line, cls_align_items_flex_start] },
                    React.createElement(HBox, null, confirmText),
                    React.createElement(HBox, { className: [cls_gap_form, cls_justify_content_space_between, cls_button_box_width] },
                        React.createElement(Button, { onClick: confirmCancelingRegistration, className: cls_button_width }, 'Odhlásit'),
                        React.createElement(Button, { onClick: cancel, intent: Intent.NotAction, className: cls_button_width }, 'Zrušit'))))));
};
var StartTypeElem = function (props) {
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    var bgColorClass = null;
    var asteriskClassByColor = cls_background_asterisk_black;
    if (props.startType === StartType.MustStart) {
        bgColorClass = cls_backgroundGreen5;
        asteriskClassByColor = cls_background_asterisk_white;
    }
    if (props.startType === StartType.CanStartUpToLimit) {
        bgColorClass = cls_backgroundBlue70;
        asteriskClassByColor = cls_background_asterisk_white;
    }
    if (props.startType === StartType.OverLimit) {
        bgColorClass = cls_backgroundOrange40;
        asteriskClassByColor = cls_background_asterisk_white;
    }
    var asteriskClass;
    if (props.startsFromRound !== undefined && props.startsFromRound !== null && props.startsFromRound > 1) {
        asteriskClass = asteriskClassByColor;
    }
    return React.createElement(VBox, { className: [cls_align_items_flex_end, cls_justify_content_center, T_HFM ? cls_competitor_start_type_box_mobile : cls_competitor_start_type_box] },
        React.createElement(HBox, { className: [cls_competitor_start_type_sign, bgColorClass, asteriskClass, cls_justify_content_center, cls_align_items_center] }));
};
var CompetitorElem = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var state_resp = useResponsivity()[0];
    var T_HFM = state_resp.thresholdHeaderForMobile;
    var _j = useEventCalendarCompetitors(), state = _j[0], actions = _j[1];
    var uiContextState = useUIContext()[0];
    var _k = useCompetitionRegistration(), actions_registration = _k[1];
    var c = props.competitor;
    var registration_state = state.registration_states.find(function (x) { return x.competitorId == c.competitorId && x.competitionId == c.competitionId; });
    var registered = registration_state.registered;
    var disable_button = registration_state.loading;
    var hasSubMembers = competitorHasSubMembers(c.type);
    var couplesOrDuosNamesRegular = [];
    var couplesOrDuosNamesBackup = [];
    var personsNamesRegular = [];
    var personsNamesBackup = [];
    if (hasSubMembers) {
        if (!!c.couplesOrDuos) {
            couplesOrDuosNamesRegular = c.couplesOrDuos.filter(function (cc) { return cc.backup !== true; }).map(function (cc) { return "".concat(cc.surname1, " ").concat(cc.name1, " & ").concat(cc.surname2, " ").concat(cc.name2); });
            couplesOrDuosNamesBackup = c.couplesOrDuos.filter(function (cc) { return cc.backup === true; }).map(function (cc) { return "".concat(cc.surname1, " ").concat(cc.name1, " & ").concat(cc.surname2, " ").concat(cc.name2); });
        }
        if (!!c.persons) {
            personsNamesRegular = c.persons.filter(function (cc) { return cc.backup !== true; }).map(function (cc) { return "".concat(cc.surname, " ").concat(cc.name); });
            personsNamesBackup = c.persons.filter(function (cc) { return cc.backup === true; }).map(function (cc) { return "".concat(cc.surname, " ").concat(cc.name); });
        }
    }
    var subCompetitorNamesRegular = __spreadArray(__spreadArray([], couplesOrDuosNamesRegular, true), personsNamesRegular, true);
    var subCompetitorNamesBackup = __spreadArray(__spreadArray([], couplesOrDuosNamesBackup, true), personsNamesBackup, true);
    var showSubMembers = state.competitors.openCompetitorCompetitionIds.includes("".concat(props.competitor.competitorId, "_").concat(props.competitor.competitionId));
    var subMemberShowOrHideAction = function () {
        actions.setCompetitorOpenOrClosed(props.competitor.competitorId, props.competitor.competitionId);
    };
    var club = "";
    if (c.club) {
        club += c.club;
    }
    var competitor = null;
    var competitorElem = null;
    if (c.type === CompetitorType.SoloDancer && c.persons !== undefined && c.persons.length === 1) {
        competitor = c.persons[0];
        competitorElem = React.createElement(VBox, { className: [cls_table_cell, cls_competitor_name_solo, useif(!registered, cls_unregistered)] }, competitor.surname + " " + competitor.name);
    }
    if ([CompetitorType.Couple, CompetitorType.Duo, CompetitorType.ProAm].includes(c.type) && c.couplesOrDuos !== undefined && c.couplesOrDuos.length === 1) {
        competitor = c.couplesOrDuos[0];
        competitorElem = React.createElement(VBox, { className: [cls_table_cell, cls_competitor_name_couple, useif(!registered, cls_unregistered)] }, competitor.surname1 + " " + competitor.name1 + " & " + competitor.surname2 + " " + competitor.name2);
    }
    if ([CompetitorType.Group, CompetitorType.Formation, CompetitorType.Team].includes(c.type)) {
        var noComponentCompetitors = (((_a = c.couplesOrDuos) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = c.persons) === null || _b === void 0 ? void 0 : _b.length) || 0) === 0;
        competitorElem = React.createElement(ButtonNoStyle, { onClick: subMemberShowOrHideAction, className: [cls_competitor_name_group] },
            React.createElement(HBox, { className: [cls_table_cell, cls_competitor_name_group, cls_cursor_pointer, useif(!registered, cls_unregistered), cls_competitor_with_sub_members_hover_background, cls_gap_quarter_rem, cls_align_items_center] },
                React.createElement(HBox, { className: [cls_chevron_right_black_box, cls_icon_box_size_18px, cls_justify_content_center, cls_align_items_center, useif(showSubMembers, cls_rotate_90deg)] }),
                noComponentCompetitors && React.createElement(HBox, { className: [cls_no_members_marker] }, "!"),
                React.createElement(HBox, null, "".concat(club && c.type === CompetitorType.Team ? "".concat(club, " ") : '').concat(c.name))));
    }
    if (c.country) {
        if (c.country != "CZE") {
            if (club) {
                club += " ";
            }
            club += "[" + c.country + "]";
        }
    }
    var dateNow = new Date();
    var nowIsBeforeRegistrationDeadline = isValidDate(props.eventCompetition.registrationDeadline) && dateNow < props.eventCompetition.registrationDeadline;
    var nowIsBeforeCancelingRegistrationDeadline = dateNow < props.eventCompetition.excuseDeadline;
    var currentUserOwnsThisCompetitor = props.ownCompetitorIds.includes(c.competitorId);
    var cancelRegistration = function () {
        if (nowIsBeforeRegistrationDeadline) {
            actions.cancelRegistrationOfCompetitor(props.eventCompetition.eventId, c.competitionId, c.competitorId);
        }
        else {
            actions.showConfirmDialog(c.competitorId, c.competitionId);
        }
    };
    var todayIsTheDayOfTheCompetition = getDateComparison(dateNow, props.eventCompetition.date);
    var currentUserIsAllowedToCancelOnTheDayOfTheCompetition = ((_d = (_c = uiContextState.data) === null || _c === void 0 ? void 0 : _c.event_registration) === null || _d === void 0 ? void 0 : _d.isCompetitionLead) === true || ((_f = (_e = uiContextState.data) === null || _e === void 0 ? void 0 : _e.event_registration) === null || _f === void 0 ? void 0 : _f.isLeadScrutineer) === true || ((_h = (_g = uiContextState.data) === null || _g === void 0 ? void 0 : _g.event_registration) === null || _h === void 0 ? void 0 : _h.isScrutineer) === true;
    var registrationCanBeCanceledByCurrentUser = (nowIsBeforeCancelingRegistrationDeadline && currentUserOwnsThisCompetitor)
        || (todayIsTheDayOfTheCompetition && currentUserIsAllowedToCancelOnTheDayOfTheCompetition);
    return React.createElement(React.Fragment, null,
        React.createElement(ConfirmCancelRegistrationDialog, { eventId: props.eventCompetition.eventId, competitor: props.competitor }),
        React.createElement(HBox, { className: [cls_align_items_stretch, cls_p5r, cls_wrap, cls_table_row] },
            React.createElement(StartTypeElem, { startType: c.startType, startsFromRound: c.startsFromRound }),
            competitorElem,
            c.type !== CompetitorType.Team && React.createElement(VBox, { className: [cls_table_cell, cls_competitor_club, useif(!registered, cls_unregistered)] }, club),
            React.createElement(VBox, { className: [T_HFM ? cls_button_or_message_mobile : cls_button_or_message, cls_justify_content_center] }, registered ? React.createElement(React.Fragment, null, registrationCanBeCanceledByCurrentUser ? React.createElement(VBox, { className: cls_table_cell },
                React.createElement(HBox, { className: [cls_item_detail_link, cls_p5r, cls_colorCyan70, cls_justify_content_flex_end, cls_gap_half_rem] },
                    c.type === CompetitorType.Team && React.createElement(ButtonSmall, { onClick: function () { actions_registration.showGroupMembersDialog(c.competitorId, c.competitionId, props.competition.ageId, c.type); }, disabled: disable_button }, "Upravit"),
                    React.createElement(ButtonSmall, { onClick: function () { return cancelRegistration(); }, disabled: disable_button, intent: Intent.NotAction }, "Odhlásit"))) : null) : React.createElement(React.Fragment, null, c.deregisteredDate ? React.createElement(VBox, { className: [cls_table_cell, cls_p6r] }, T_HFM ? React.createElement(HBox, null,
                "odhl\u00E1\u0161eno: ",
                getDateAndTimeText_DayMonthHourMinute(c.deregisteredDate)) : React.createElement(VBox, null,
                React.createElement(HBox, null, "odhl\u00E1\u0161eno"),
                React.createElement(HBox, null, getDateAndTimeText_DayMonthHourMinute(c.deregisteredDate)))) : null))),
        registration_state.error !== null ? React.createElement(HBox, { className: [cls_align_items_stretch, cls_p5r] },
            React.createElement(VBox, { className: [cls_table_cell, cls_colorMagenta60] }, registration_state.error)) : React.createElement(React.Fragment, null),
        hasSubMembers && showSubMembers && React.createElement(VBox, { className: [cls_table_cell, cls_p6r] },
            !!c.captain && React.createElement(HBox, null, "Kapit\u00E1n: ".concat(c.captain)),
            subCompetitorNamesRegular.length > 0 || subCompetitorNamesBackup.length > 0
                ? React.createElement(React.Fragment, null,
                    subCompetitorNamesRegular.length > 0 && React.createElement(HBox, null, "\u010Clenov\u00E9: ".concat(subCompetitorNamesRegular.join(", "))),
                    subCompetitorNamesBackup.length > 0 && React.createElement(HBox, null, "N\u00E1hradn\u00EDci: ".concat(subCompetitorNamesBackup.join(", "))))
                : React.createElement(HBox, { className: cls_colorMagenta60 }, "".concat(getCompetitorTypeRegular(c.type), " neobsahuje \u017E\u00E1dn\u00E9 \u010Dleny."))));
};
var NumberOfCompetitorsSoloDancers = function (number) {
    if (number === 1) {
        return "".concat(number, " jednotlivec");
    }
    else if (number >= 2 && number <= 4) {
        return "".concat(number, " jednotlivci");
    }
    else {
        return "".concat(number, " jednotlivc\u016F");
    }
};
var NumberOfCompetitors = function (number, competitorType) {
    var competitorNaming = null;
    if (competitorType === CompetitorType.Couple) {
        if (number === 1) {
            competitorNaming = 'pár';
        }
        else if (number >= 2 && number <= 4) {
            competitorNaming = 'páry';
        }
        else {
            competitorNaming = 'párů';
        }
    }
    if (competitorType === CompetitorType.ProAm) {
        if (number === 1) {
            competitorNaming = 'ProAm pár';
        }
        else if (number >= 2 && number <= 4) {
            competitorNaming = 'ProAm páry';
        }
        else {
            competitorNaming = 'ProAm párů';
        }
    }
    if (competitorType === CompetitorType.SoloDancer) {
        if (number >= 1 && number <= 4) {
            competitorNaming = 'soutěžící';
        }
        else {
            competitorNaming = 'soutěžících';
        }
    }
    if (competitorType === CompetitorType.Formation) {
        if (number >= 1 && number <= 4) {
            competitorNaming = 'formace';
        }
        else {
            competitorNaming = 'formací';
        }
    }
    if (competitorType === CompetitorType.Duo) {
        if (number === 1) {
            competitorNaming = 'duo';
        }
        else if (number >= 2 && number <= 4) {
            competitorNaming = 'dua';
        }
        else {
            competitorNaming = 'duí';
        }
    }
    if (competitorType === CompetitorType.Group) {
        if (number === 1) {
            competitorNaming = 'skupina';
        }
        else if (number >= 2 && number <= 4) {
            competitorNaming = 'skupiny';
        }
        else {
            competitorNaming = 'skupin';
        }
    }
    if (competitorType === CompetitorType.Team) {
        if (number === 1) {
            competitorNaming = 'tým';
        }
        else if (number >= 2 && number <= 4) {
            competitorNaming = 'týmy';
        }
        else {
            competitorNaming = 'týmů';
        }
    }
    if (competitorNaming !== null) {
        return "".concat(number, " ").concat(competitorNaming);
    }
    return "".concat(number);
};
var NumberOfCompetitorsForCompetition = function (props) {
    return React.createElement(React.Fragment, null, "po\u010Det: ".concat(NumberOfCompetitors(props.number, props.competition.competitorId)));
};
var CompetitionElem = function (props) {
    var state_resp = useResponsivity()[0];
    var T_U700 = state_resp.thresholdUnder700;
    var _a = useEventCalendarCompetitors(), state = _a[0], actions = _a[1];
    var competitors = state.competitors.collection;
    var numCompetitors = state.registration_states.filter(function (s) { return s.competitionId === props.c.id && s.registered; }).length;
    var showCompetitors = state.competitions.openCompetitionIds.includes(props.c.id);
    return React.createElement(VBox, { className: cls_comp_competitors_box },
        React.createElement(ButtonNoStyle, { onClick: function () { return actions.setCompetitionOpenOrClosed(props.c.id); } },
            React.createElement(HBox, { className: [T_U700 ? cls_table_caption_row_dense : cls_table_caption_row, cls_justify_content_space_between, cls_cursor_pointer, cls_table_caption_row_hover_background] },
                React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_p5b] },
                    React.createElement(HBox, null, getCompetitionNaming(props.c))),
                React.createElement(VBox, { className: [cls_table_cell, cls_align_items_center, cls_justify_content_center, cls_p5b] },
                    React.createElement(HBox, { className: cls_gap_half_rem },
                        React.createElement(NumberOfCompetitorsForCompetition, { number: numCompetitors, competition: props.c }),
                        React.createElement(HBox, { className: [cls_chevron_right_white_box, cls_icon_box_size_24px, cls_justify_content_center, cls_align_items_center, useif(!showCompetitors, cls_rotate_180deg), useif(showCompetitors, cls_rotate_90deg)] }))))),
        showCompetitors && React.createElement(VBox, { className: [T_U700 ? cls_table_body_dense : cls_table_body] }, competitors.filter(function (c) { return c.competitionId == props.c.id; }).map(function (competitor) { return React.createElement(CompetitorElem, { key: competitor.competitorId, competitor: competitor, eventCompetition: props.eventCompetition, ownCompetitorIds: props.ownCompetitorIds, competition: props.c }); })));
};
var NumbersOfCompetitors = function (props) {
    var state_calendar = useEventCalendarList()[0];
    var _a = useEventCalendarCompetitors(), state = _a[0], actions = _a[1];
    var registrationStates = state.registration_states;
    var competitors = state.competitors.collection.filter(function (c) { return registrationStates.find(function (r) { return r.competitorId === c.competitorId && r.competitionId === c.competitionId; }).registered === true; });
    var competitorIdts = [];
    var competitorsOfTypeCouple = competitors.filter(function (c) { return c.type === CompetitorType.Couple; });
    var competitorsOfTypeDuo = competitors.filter(function (c) { return c.type === CompetitorType.Duo; });
    var competitorsOfTypeSoloDancer = competitors.filter(function (c) { return c.type === CompetitorType.SoloDancer; });
    var competitorsOfTypeGroup = competitors.filter(function (c) { return c.type === CompetitorType.Group; });
    var competitorsOfTypeFormation = competitors.filter(function (c) { return c.type === CompetitorType.Formation; });
    var competitorsOfTypeTeam = competitors.filter(function (c) { return c.type === CompetitorType.Team; });
    var competitorsOfTypeProAm = competitors.filter(function (c) { return c.type === CompetitorType.ProAm; });
    var numberOfTypeCouple = competitorsOfTypeCouple.length;
    var numberOfTypeDuo = competitorsOfTypeDuo.length;
    var numberOfTypeSoloDancer = competitorsOfTypeSoloDancer.length;
    var numberOfTypeGroup = competitorsOfTypeGroup.length;
    var numberOfTypeFormation = competitorsOfTypeFormation.length;
    var numberOfTypeTeam = competitorsOfTypeTeam.length;
    var numberOfTypeProAm = competitorsOfTypeProAm.length;
    var numberOfUniqueOfTypeCouple = competitorsOfTypeCouple.map(function (c) { return "".concat(c.couplesOrDuos[0].idt1, "-").concat(c.couplesOrDuos[0].idt2); }).filter(function (val, idx, arr) { return idx === arr.indexOf(val); }).length;
    var numberOfUniqueOfTypeDuo = competitorsOfTypeDuo.map(function (c) { return "".concat(c.couplesOrDuos[0].idt1, "-").concat(c.couplesOrDuos[0].idt2); }).filter(function (val, idx, arr) { return idx === arr.indexOf(val); }).length;
    var numberOfUniqueOfTypeSoloDancer = competitorsOfTypeSoloDancer.map(function (c) { return "".concat(c.persons[0].idt); }).filter(function (val, idx, arr) { return idx === arr.indexOf(val); }).length;
    var numberOfUniqueOfTypeGroup = competitorsOfTypeGroup.map(function (c) { return "".concat(c.competitorId, "-").concat(c.competitionId); }).filter(function (val, idx, arr) { return idx === arr.indexOf(val); }).length;
    var numberOfUniqueOfTypeFormation = competitorsOfTypeFormation.map(function (c) { return "".concat(c.competitorId, "-").concat(c.competitionId); }).filter(function (val, idx, arr) { return idx === arr.indexOf(val); }).length;
    var numberOfUniqueOfTypeTeam = competitorsOfTypeTeam.map(function (c) { return "".concat(c.competitorId, "-").concat(c.competitionId); }).filter(function (val, idx, arr) { return idx === arr.indexOf(val); }).length;
    var numberOfUniqueOfTypeProAm = competitorsOfTypeProAm.map(function (c) { return "".concat(c.couplesOrDuos[0].idt1, "-").concat(c.couplesOrDuos[0].idt2); }).filter(function (val, idx, arr) { return idx === arr.indexOf(val); }).length;
    var numberOfCompetitors = numberOfTypeCouple + numberOfTypeDuo + numberOfTypeSoloDancer + numberOfTypeGroup + numberOfTypeFormation + numberOfTypeTeam + numberOfTypeProAm;
    var numberOfUniqueCompetitors = numberOfUniqueOfTypeCouple + numberOfUniqueOfTypeDuo + numberOfUniqueOfTypeSoloDancer + numberOfUniqueOfTypeGroup + numberOfUniqueOfTypeFormation + numberOfUniqueOfTypeTeam + numberOfUniqueOfTypeProAm;
    competitors.forEach(function (c) {
        if (c.persons !== undefined) {
            c.persons.forEach(function (p) { competitorIdts.push(p.idt); });
        }
        if (c.couplesOrDuos !== undefined) {
            c.couplesOrDuos.forEach(function (p) { competitorIdts.push(p.idt1); competitorIdts.push(p.idt2); });
        }
    });
    var competitorNumbers = [
        "".concat(numberOfCompetitors, " ").concat(numberOfCompetitors >= 5 ? "soutěžících" : "soutěžící"),
        "".concat(numberOfUniqueCompetitors, " ").concat(numberOfUniqueCompetitors >= 5 ? "unikátních" : "unikátní")
    ];
    if (numberOfTypeCouple) {
        competitorNumbers.push("".concat(NumberOfCompetitors(numberOfTypeCouple, CompetitorType.Couple)));
    }
    if (numberOfTypeDuo) {
        competitorNumbers.push("".concat(NumberOfCompetitors(numberOfTypeDuo, CompetitorType.Duo)));
    }
    if (numberOfTypeSoloDancer) {
        competitorNumbers.push("".concat(NumberOfCompetitorsSoloDancers(numberOfTypeSoloDancer)));
    }
    if (numberOfTypeGroup) {
        competitorNumbers.push("".concat(NumberOfCompetitors(numberOfTypeGroup, CompetitorType.Group)));
    }
    if (numberOfTypeFormation) {
        competitorNumbers.push("".concat(NumberOfCompetitors(numberOfTypeFormation, CompetitorType.Formation)));
    }
    if (numberOfTypeTeam) {
        competitorNumbers.push("".concat(NumberOfCompetitors(numberOfTypeTeam, CompetitorType.Team)));
    }
    if (numberOfTypeProAm) {
        competitorNumbers.push("".concat(NumberOfCompetitors(numberOfTypeProAm, CompetitorType.ProAm)));
    }
    var competitorNumbersString = competitorNumbers.join(", ");
    var downloadListOfParticipants = function () {
        var p = state_calendar.selectedEventItem;
        var url = "".concat(UrlPathOfApiLocation, "/api/1/events/").concat(props.eventId, "/competitors");
        var fileName = "".concat(getIsoStringDate(p.date), " - ").concat(p.city, " - ").concat(p.name, " - ").concat(p.id, " - sout\u011B\u017E\u00EDc\u00ED.xlsx");
        var headers = {
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };
        fetch(url, { headers: headers })
            .then(function (response) { return response.blob(); })
            .then(function (blob) {
            var a = document.createElement("a");
            a.setAttribute('style', 'display: none;');
            document.body.appendChild(a);
            var urlDownload = window.URL.createObjectURL(blob);
            a.href = urlDownload;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(urlDownload);
        }).catch(function (err) {
            console.log(err);
        });
    };
    return React.createElement(React.Fragment, null, numberOfCompetitors > 0 && React.createElement(HBox, { className: [cls_justify_content_space_between, cls_box_number_of_competitors, cls_align_items_flex_start] },
        React.createElement(HBox, { className: [cls_p5r, cls_gap_half_rem, cls_wrap] },
            React.createElement(HBox, { className: cls_p5b }, "Celkov\u00E9 po\u010Dty:"),
            React.createElement(HBox, null, competitorNumbersString)),
        React.createElement(HBox, { className: [cls_justify_content_flex_end, cls_gap_form, cls_wrap] },
            React.createElement(ButtonNoStyle, { onClick: downloadListOfParticipants },
                React.createElement(HBox, { className: [cls_cursor_pointer, cls_link_blue, cls_p5r] }, "St\u00E1hnout")),
            React.createElement(ButtonNoStyle, { onClick: actions.setAllCompetitionsClosed },
                React.createElement(HBox, { className: [cls_cursor_pointer, cls_link_blue, cls_p5r] }, "Sbalit v\u0161e")),
            React.createElement(ButtonNoStyle, { onClick: actions.setAllCompetitionsOpen },
                React.createElement(HBox, { className: [cls_cursor_pointer, cls_link_blue, cls_p5r] }, "Rozbalit v\u0161e")))));
};
var Content = function (props) {
    var _a, _b;
    var state = useEventCalendarCompetitors()[0];
    var competitions = state.competitions.collection;
    var uiContextState = useUIContext()[0];
    var own_attendees = ((_b = (_a = uiContextState.data) === null || _a === void 0 ? void 0 : _a.event_registration) === null || _b === void 0 ? void 0 : _b.attendees) || [];
    var ownCompetitorIds = own_attendees.filter(function (a) { return a.competitorId != null; }).map(function (a) { return a.competitorId; });
    return React.createElement(VBox, null,
        React.createElement(NumbersOfCompetitors, { eventId: props.eventId }),
        competitions.map(function (comp) { return React.createElement(CompetitionElem, { key: comp.id, c: comp, eventCompetition: props.eventCompetition, ownCompetitorIds: ownCompetitorIds }); }),
        React.createElement(GroupOrFormationMembersDialog, null));
};
var View = function (_a) {
    var _b, _c;
    var eventId = _a.eventId, eventCompetitionId = _a.eventCompetitionId, eventCompetition = _a.eventCompetition;
    var _d = useUIContext(), uiContextState = _d[0], loadEventRegistrationUIContext = _d[1].loadEventRegistrationUIContext;
    var _e = useEventCalendarCompetitors(), state = _e[0], actions = _e[1];
    var eventRegistration = (_b = uiContextState.data) === null || _b === void 0 ? void 0 : _b.event_registration;
    var _f = useCompetitionRegistration(), setAvailableAttendees = _f[1].setAvailableAttendees;
    React.useEffect(function () {
        if (eventRegistration) {
            setAvailableAttendees(eventRegistration.attendees);
        }
    }, [eventRegistration]);
    var loading = state.competitions.loading || state.competitors.loading;
    var loadingTooLong = state.competitions.loadingTooLong || state.competitors.loadingTooLong;
    var loadFailure = state.competitions.loadFailure || state.competitors.loadFailure;
    React.useEffect(function () {
        if (state.not_logged) {
            actions.resetNotLoggedFlag();
        }
        if (uiContextState.data.logged_user) {
            loadEventRegistrationUIContext(EventType.Competition, eventCompetitionId);
        }
    }, [eventCompetitionId, (_c = uiContextState.data.logged_user) === null || _c === void 0 ? void 0 : _c.email, state.not_logged]);
    React.useEffect(function () {
        actions.loadCompetitions(eventId, eventCompetitionId, "type");
        actions.loadCompetitors(eventId, eventCompetitionId);
    }, []);
    var showContent = !loading && !loadFailure;
    return React.createElement(VBox, null,
        loadingTooLong && React.createElement(LoadingSpinner, null),
        loadFailure && React.createElement(LoadingError, null),
        showContent && React.createElement(Content, { eventId: eventId, eventCompetitionId: eventCompetitionId, eventCompetition: eventCompetition }));
};
export { View as Competitors, };
